import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import Reveal from "../Reveal";
import ArtistCard from "../ArtistCard";
import { artists, studio } from "../../mock";

const FEATURED_COUNT = 6;

const ArtistsSection = () => {
  const featured = artists.slice(0, FEATURED_COUNT);

  return (
    <section className="relative py-24 lg:py-32" id="artists" data-testid="artists-section">
      <div className="container-x">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Reveal>
              <p className="eyebrow">Our Artists</p>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="display mt-6 text-[clamp(3.5rem,8vw,8rem)] uppercase leading-[0.85] tracking-wide">
                The <span className="text-stroke">Collective</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={160} className="max-w-md">
            <p className="text-sm leading-relaxed text-muted-foreground md:text-base">
              <span className="font-semibold text-primary">To Book: </span>
              {studio.bookingNote}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((artist, i) => (
            <Reveal key={artist.id} delay={(i % 3) * 90}>
              <ArtistCard artist={artist} index={i} />
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 flex flex-col items-start gap-6 border-t border-border pt-10 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-muted-foreground">
            Showing {featured.length} of {artists.length} resident artists.
          </p>
          <Button
            asChild
            size="lg"
            className="h-12 rounded-none px-7 text-[11px] font-semibold uppercase tracking-[0.2em]"
            data-testid="artists-view-all"
          >
            <Link to="/artists">
              View all {artists.length} artists <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </Reveal>
      </div>
    </section>
  );
};

export default ArtistsSection;
